export default __webpack_public_path__ + "static/media/web-design.090de608.png";